
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/security",
      function () {
        return require("private-next-pages/company/security.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/security"])
      });
    }
  